import React from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import logo from '../../assets/logo_dourado.png';
import './styles.scss';

const Header: React.FC = () => {
  return (
    <header className="itauna-header">
      <div className="header-content">
        <Link to="/" className="header-logo-link">
          <img src={logo} alt="Itaúna Logo" className="header-logo-img" />
        </Link>        
        <a 
          className="client-area-button" 
          href="https://itauna.smartbrain.com.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="button-content-wrapper">
            <span className="button-text">ÁREA DO CLIENTE</span>
          </span>
        </a>
      </div>
    </header>
  );
};

export default Header;
